/**
 * Security Summary dashboard card icon.
 *
 * fill uses `currentColor` (not the hardcoded #141414 from the source SVG)
 * so it inherits the card's own text color — dashboard cards render white
 * icon/text on a blue gradient background (see .dashboard-card in
 * details/styles.ts), and a hardcoded dark fill would be nearly invisible
 * there.
 */
export function SecuritySummaryIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 2C3 1.44772 3.44772 1 4 1H9.79289C10.0581 1 10.3125 1.10536 10.5 1.29289L12.7071 3.5C12.8946 3.68754 13 3.94189 13 4.20711V14C13 14.5523 12.5523 15 12 15H4C3.44771 15 3 14.5523 3 14V2ZM11 8H5V9H11V8ZM5 11V12H10V11H5Z"
        fill="currentColor"
      />
    </svg>
  );
}
